/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_DescriptionInputs */

const en_app_description = /** @type {(inputs: App_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule, training plans and payments in one place. Your own online booking page, built for personal trainers.`)
};

const pl_app_description = /** @type {(inputs: App_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafik, plany treningowe i płatności w jednym miejscu. Własna strona z rezerwacjami online dla trenerów personalnych.`)
};

/**
* | output |
* | --- |
* | "Schedule, training plans and payments in one place. Your own online booking page, built for personal trainers." |
*
* @param {App_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const app_description = /** @type {((inputs?: App_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_app_description(inputs)
	return en_app_description(inputs)
});